import { CONDITION_STATUS, CONDITION_STATUS_JA, LANGUAGE } from '../../../constants';
import type { ProcessCellCallbackParams } from '../../../types/common';
import type { Language, SelectOption } from '../../../types/common';

const conditionStatusCellCallback = (params: ProcessCellCallbackParams): string => {
  const value = params.value;
  const currentLang: SelectOption<Language> | undefined = params.context?.currentLang;
  const filterValue: string | undefined = currentLang ? (currentLang.value === LANGUAGE.JA ? CONDITION_STATUS_JA[value] : CONDITION_STATUS[value]) : value;
  return filterValue;
};

export default conditionStatusCellCallback;
